import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';
import actions from '../actions';

//REDUCERS
const availActions = actions.avail;
export default handleActions(
  {
    [combineActions(availActions.getAsync.toString(),availActions.getLoyaltyAvailAsync.toString())]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails
            .setIn([hotelId, key, 'raw_response'], avail.getIn([key, 'raw_response']))
            .setIn([hotelId, key, 'is_alter_search'], avail.getIn([key, 'is_alter_search'], false))
            .setIn([hotelId, key, 'last_request'], avail.getIn([key, 'last_request'], false))
            .setIn([hotelId, key, 'request_duration'], avail.getIn([key, 'request_duration'], false));
        });
      });
      return avails;
    },
    [availActions.getFlexibleAsync.toString()]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails
            .setIn([hotelId, key, 'flexible_raw_response'], avail.getIn([key, 'flexible_raw_response']));
        });
      });
      return avails;
    },
    [availActions.getLoyaltyFlexibleAsync.toString()]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails
            .setIn([hotelId, key, 'flexible_raw_response'], avail.getIn([key, 'flexible_raw_response']));
        });
      });
      return avails;
    },
    [availActions.getAvailAsync.toString()]: (avails, { payload }) => {
      if(!payload || !payload.payload) return avails;
      payload.payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails
            .setIn([hotelId, key, 'raw_response'], avail.getIn([key, 'raw_response']))
            .setIn([hotelId, key, 'is_alter_search'], avail.getIn([key, 'is_alter_search'], false))
            .setIn([hotelId, key, 'last_request'], avail.getIn([key, 'last_request'], false))
            .setIn([hotelId, key, 'request_duration'], avail.getIn([key, 'request_duration'], false));
        });
      });
      return avails
    },
    [availActions.getAvailParsed.toString()]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails.setIn([hotelId, key, 'response'], avail.getIn([key, 'response']))
          if(avail.getIn([key,'is_alter_search']) !== undefined) {
            avails = avails.setIn([hotelId, key, 'is_alter_search'], avail.getIn([key, 'is_alter_search']))
          }
        });
      });
      return avails;
    },
    [availActions.resetAvail.toString()]: (avails, { payload }) => {
      return avails.set(payload, Map());
    },
    [combineActions(availActions.getParsedAvail.toString(),availActions.getLoyaltyParsedAvail.toString())]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        const firstKey = avail.keySeq().first();
        avails = avails.setIn([hotelId, firstKey, 'response'], avail.getIn([firstKey, 'response']));
      });
      return avails;
    },
  },
  Map()
);

//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
